export const CUSTOMER_WEB_URL =
  process.env.NODE_ENV === 'development'
    ? process.env.REACT_APP_CUSTOMER_WEB_URL ??
      'https://getinked-web-w74fr6mhza-uc.a.run.app'
    : 'https://web.getporter.io';
export const DEFAULT_CUSTOMER_SERVICE_FEE = 0.035;
export const DEFAULT_PER_CHARGE_CENTS_FEES = 30;
export const ROUTES = {
  calendar: '/calendar',
  requests: '/requests',
  customers: '/customers',
  shop: '/shop',
  subscription: '/subscription',
  plans: '/plans',
  waivers: '/waivers',
  payments: '/payments',
  team: '/team',
  bookingLinks: '/booking-links',
  marketing: '/marketing',
  chat: '/chat',
  items: '/items',
  import: '/import',
  waiverRequest: '/waiver-request',
  notifications: '/notifications',
} as const;
export const DEV = process.env.NODE_ENV === 'development';
export const MAX_FILE_SIZE = 25 * 1024 * 1024; // 25MB

export const FILTER_PERSISTENCE_KEYS = {
  calendarArtists: 'calendar-artists',
  customerArtists: 'customer-artists',
} as const;

export const SUPPORT_URL = 'https://support.getporter.io/';
